import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {AsYouType} from 'libphonenumber-js';
import classNames from 'classnames';

import styles from './FormPhoneNumber.scss';
import FormField from './FormField';

export default class FormPhoneNumber extends Component {
    static propTypes = {
        type: PropTypes.string,
        className: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.string,
        error: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        type: 'text'
    };

    state = {
        isFormatted: true
    };

    render() {
        const {
            label,
            className,
            error,
            disabled,
            placeholder,
            value
        } = this.props;
        const {isFormatted} = this.state;
        const inputClassName = classNames(styles.field, className, {
            [styles.highlightError]: Boolean(error)
        });
        const phoneNumber = value && value.length > 5
            ? new AsYouType('US').input(value)
            : value;

        return (
            <FormField label={label}
                className={className}
                error={error}>
                <input type={'tel'}
                    className={inputClassName}
                    placeholder={placeholder}
                    value={isFormatted ? phoneNumber : value}
                    onChange={ this.handleChange}
                    disabled={disabled}
                       onFocus={() => {
                    this.setState({isFormatted: false})
                }}
                onBlur={() => {
                    this.setState({isFormatted: true})
                }}
                />
            </FormField>
        );
    }

    handleChange = (e) => {
        const {onChange} = this.props;
        const {value} = e.target;
        const parsed = value.match(/(\d|-|\+|\(|\))/g);
        onChange({target: {value: parsed ? parsed.join('') : ''}});
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormPhoneNumber.js